export const tableHeaders = ['Name', 'Proteins', 'Fat', 'Carbohydrates', 'kCal'];
